// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"2ef314ed","88":"8be15641","109":"1eeb77a3","130":"e7084c48","164":"f6aeca08","278":"efd361ca","310":"4b1158fe","359":"5219022c","450":"988d3ada","453":"398c14bc","791":"f14b1a8a","894":"80d2e844"}[chunkId] + ".chunk.js";
};